export function getSizeRange(longestSideMeters) {
  if (
    longestSideMeters === undefined ||
    longestSideMeters === null ||
    isNaN(longestSideMeters)
  ) {
    return "total";
  }

  const size = Number(longestSideMeters);

  // All ranges are 20 cm (0.2m) between 0 and 3.6m, plus one bucket above 3.6m
  if (size < 0.2) return "0-0.2";
  if (size < 0.4) return "0.2-0.4";
  if (size < 0.6) return "0.4-0.6";
  if (size < 0.8) return "0.6-0.8";
  if (size < 1.0) return "0.8-1.0";
  if (size < 1.2) return "1.0-1.2";
  if (size < 1.4) return "1.2-1.4";
  if (size < 1.6) return "1.4-1.6";
  if (size < 1.8) return "1.6-1.8";
  if (size < 2.0) return "1.8-2.0";
  if (size < 2.2) return "2.0-2.2";
  if (size < 2.4) return "2.2-2.4";
  if (size < 2.6) return "2.4-2.6";
  if (size < 2.8) return "2.6-2.8";
  if (size < 3.0) return "2.8-3.0";
  if (size < 3.2) return "3.0-3.2";
  if (size < 3.4) return "3.2-3.4";
  if (size <= 3.6) return "3.4-3.6";
  return ">3.6";
}

// Objects without longestSideMeters are counted under "total".
export function hasObjectSizes(sizeRangeDistribution) {
  const labels = sizeRangeDistribution?.labels || [];
  const data = sizeRangeDistribution?.data || [];
  return labels.some((range, index) => range !== "total" && data[index] > 0);
}

export const SIZE_RANGES = [
  "0-0.2",
  "0.2-0.4",
  "0.4-0.6",
  "0.6-0.8",
  "0.8-1.0",
  "1.0-1.2",
  "1.2-1.4",
  "1.4-1.6",
  "1.6-1.8",
  "1.8-2.0",
  "2.0-2.2",
  "2.2-2.4",
  "2.4-2.6",
  "2.6-2.8",
  "2.8-3.0",
  "3.0-3.2",
  "3.2-3.4",
  "3.4-3.6",
  ">3.6",
  "total",
];
